import React, { useState } from 'react';

import Search from '../search/Search';
import Burger from '../burger/Burger';
// import UserAndActions from '../user-and-actions/UserAndActions';

import { FiSearch, FiX } from 'react-icons/fi';

import {
  HeaderContent,
  Logo,
  HeaderContainer,
  SearchIconContainer,
  UserAndActions
} from './Header.styles';

const Header = ({ open, setOpen, isSignInRoute }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  const handleClick = () => {
    setSearchOpen(!searchOpen);
  };

  return (
    <HeaderContainer className="py" open={open}>
      <HeaderContent className="container">
        <SearchIconContainer onClick={handleClick}>
          {searchOpen ? <FiX /> : <FiSearch />}
        </SearchIconContainer>
        <Logo to="/" open={open}>
          CAST.IO
        </Logo>
        <Search searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
        {!isSignInRoute && <Burger open={open} setOpen={setOpen} />}
        <UserAndActions>
          <UserAndActions />
        </UserAndActions>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
